import { dictionary } from '../langs/fa/fa';
export function __(text = '') {
  return typeof text === 'string'
    ? dictionary[text.trim()]
      ? dictionary[text.trim()]
      : text.trim()
    : '';
}
